import { Pipe, PipeTransform } from '@angular/core';
import { UgerapportSager } from '@store/models';

@Pipe({
    name: 'ugerapportSagerFilter',
    pure: false,
    standalone: false
})
export class UgerapportSagerFilterPipe implements PipeTransform {
    transform(ugerapportSager: UgerapportSager[], kid: number): any {
        return ugerapportSager.filter(s => s.kid === (kid || 0));
    }
}
